// extracted by mini-css-extract-plugin
export default {"preparation":"oyGQP","image-wrapper":"AqOpk"};